import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Sparkles } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-sky-600 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-bold text-lg text-white">
                West Texas Sparkle
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Professional cleaning services for homes and offices in Lubbock, TX and surrounding areas. 
              Trusted, reliable, and affordable.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: "Home", path: "/" },
                { name: "Services", path: "/services" },
                { name: "About Us", path: "/about" },
                { name: "Gallery", path: "/gallery" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Services</h3>
            <ul className="space-y-2">
              {[
                "Standard House Cleaning",
                "Deep Cleaning",
                "Move-In/Move-Out",
                "Office Cleaning",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:8065558123"
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4 text-sky-500" />
                  (806) 555-8123
                </a>
              </li>
              <li>
                <a
                  href="mailto:westtexassparkle@gmail.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-sky-500" />
                  westtexassparkle@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-sky-500 mt-0.5" />
                <span>Lubbock, Wolfforth, Levelland, TX</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Clock className="w-4 h-4 text-sky-500" />
                Mon–Sat: 8am–6pm
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} West Texas Sparkle Cleaning. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Serving Lubbock, Wolfforth, and Levelland, TX
            </p>
          </div>
        </div>
      </div>

      {/* Mobile Sticky CTA */}
      <div className="sticky-cta md:hidden">
        <a
          href="tel:8065558123"
          className="flex items-center justify-center gap-2 w-full py-3 bg-sky-600 text-white font-semibold rounded-full shadow-lg"
          data-testid="mobile-sticky-call"
        >
          <Phone className="w-5 h-5" />
          Call Now - (806) 555-8123
        </a>
      </div>
    </footer>
  );
};

export default Footer;
